<template>
    <div class="nav">
        <ul>
            <li v-for="(list,index) in lists" :key="list.name"
            @mouseover="handleOver(list)"
            @mouseout="handleOut(list)"
            >
                <a href="#">{{ list.name }}</a>
                <transition name="fade"
                @before-enter="beforeEnter"
                @enter="enter"
                @leave="leave"
                >                
                <div class="subnav" v-if="list.isActive" :data-index="index">
                    <em class="arrow"></em>
                    <p>
                        <span>
                            <a href="#" v-for="item in list.subname" :key="item.mes">
                                {{item.mes }} {{item.bar}}
                            </a>
                        </span>
                    </p>
                </div>
                </transition>
            </li>
        </ul>
    </div>
</template>
<script>
import {lists} from './components/lists';
import { setTimeout } from 'timers';
export default {
    name:'Test',
    data(){
        return{                       
            lists:lists
        }
    },
    methods:{
        handleOver(list){
            list.isActive=true
        },
        handleOut(list){
            list.isActive=false
        },
        beforeEnter(el){
            el.style.display='none'
        },
        enter(el,done){
            el.style.display='block';
            var nav=el.offsetParent;
            var myUl=el.offsetParent.firstChild;
            var myLi=myUl.childNodes;
            var index=el.dataset.index;
            var em=el.firstChild;

            nav.offsetWidth - myLi[index].offsetLeft > el.offsetWidth ?
            el.style.left = myLi[index].offsetLeft + 'px' :
            el.style.right =0;

            em.style.left=myLi[index].offsetLeft - el.offsetLeft + 50 + 'px';

            done()

        },
        leave(el,done){
            setTimeout(function(){
                el.style.display='none'
            },300)
            done()
        }
    }
}
</script>
<style>
.fade-leave-active{
    transition: all  .3s ease;
}
.fade-enter, .fade-leave-to{
    display: none;
}

body, div, ul, li, p{
    margin: 0;
    padding: 0;
}
body{
    font: 12px/1.5 arial;
}
ul{
    list-style-type: none;
}
.nav, .nav ul, .nav ul li, .nav ul li a:hover, .nav .subnav, .nav .subnav p, .nav .subnav p span, .nav .subnav .arrow{
    background: url(./assets/lesson4/nav_bg.png) no-repeat;
}
.nav{
    position: relative;
    width: 910px;
    background-position: 0 -36px;
    margin:10px auto;
}
.nav ul{
    height: 36px;
    line-height: 36px;
    margin-left: 10px;
    padding-right: 10px;
    overflow: hidden;
    background-position: right -72px;
}
.nav ul li{
    float: left;
    width: 110px;
    margin-left: -2px;
    background-position: 0 -108px;
}
.nav ul li a{
    font-size: 14px;
    color: #fff;
    width: 102px;
    display: block;
    text-align: center;
    text-decoration: none;
    margin: 0 2px 0 4px;
}
.nav ul li a:hover{
    font-weight: 700;
    background-position: -3px -144px;
}
.nav .subnav{
    
    position: absolute;
    top:41px;
    width: auto !important;
    min-width: 110px;
    height: 27px;
    line-height: 27px;
    white-space: nowrap;
    background-position: 0 -180px;
}
.nav .subnav p{
    margin-left: 10px;
    padding-right: 10px;
    background-position: right -234px;
}
.nav .subnav p span{
    display: block;
    color: #235e99;
    background-repeat: repeat-x;
    background-position: 0 -207px;
}
.nav .subnav p a{
    font-size: 12px;
    display: inline;
    color: #235e99;
    text-decoration: none;
    margin: 0 5px;
    padding: 0 2px;
}
.nav .subnav p a:hover{
    font-weight: 400;
    background-image: none;
    border-bottom: 2px solid;
}
.nav .subnav .arrow{
    position: absolute;
    top:-4px;
    display: block;
    width: 11px;
    height: 5px;
    background-position: 0 -261px;
}
</style>
